(function () {
  function closeItem(item) {
    item.classList.remove('is-open');
    var btn = item.querySelector('[data-vb-science-trigger]');
    var panel = item.querySelector('[data-vb-science-panel]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
  }

  function openItem(item) {
    item.classList.add('is-open');
    var btn = item.querySelector('[data-vb-science-trigger]');
    var panel = item.querySelector('[data-vb-science-panel]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (panel) panel.hidden = false;
  }

  function init(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-vb-science-item]'));
    items.forEach(function (item) {
      var btn = item.querySelector('[data-vb-science-trigger]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(closeItem);
        if (!isOpen) openItem(item);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-vb-pdp-science]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-vb-pdp-science]');
    if (root) init(root);
  });
})();
